<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">联系我们</div>
      <div class="t-t2box">
        <div class="t-t2">电话 ： &nbsp; {{ userInfo.contact_tel }}({{ userInfo.contact_name }})</div>
        <div class="t-t2">地址 ： &nbsp; {{ userInfo.contact_address }}</div>
        <div class="t-t2">邮箱 ： &nbsp; {{ userInfo.contact_email }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AaacuuxIndex',

  data() {
    return {
      userInfo: {},
    }
  },

  mounted() {
    this.getwebConfig()
  },

  methods: {
    goNewX() {
      this.$router.push('/newsx')
    },
    getwebConfig() {
      this.$axios
        .get('/index/Dt/webConfig', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.userInfo = res.data.data
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}

// 顶部
.top {
  z-index: -1;
  position: relative;
  height: 600px;
  background-image: url('@/image/contact/banner.png');

  .t-t1 {
    font-size: 60px;
    color: #fff;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #fff;
    z-index: 100;
    position: absolute;
    top: 45%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}
.top::after {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  content: '';
  display: block;
  background: rgba(0, 0, 0, 0.3);
  // background-color: #333333;
}

.box1 {
  width: 72%;
  height: 1520px;
  display: flex;
  margin: 60px auto;
  // background-color: #fafafa;
  padding-left: 180px;

  .boxleft {
    width: 820px;
    height: 100%;
    padding-top: 3px;

    margin-right: 60px;

    .item {
      box-shadow: 50px 10px 100px 5px #fafafa;
      // box-shadow: -3px -3px 3px 3px #fafafa;
      position: relative;
      width: 820px;
      height: 160px;
      // border: 1px solid;
      border-radius: 4px;

      margin-bottom: 10px;
      background-color: #ffffff;

      .le1 {
        margin-left: 15px;
        top: 25px;
        position: absolute;
        width: 500px;
        height: 108px;
        .title {
          line-height: 28px;
          letter-spacing: 1px;
          font-size: 18px;
        }
        .time {
          position: absolute;
          bottom: 0;
          color: #999999;
        }
      }

      .le2 {
        margin-left: 15px;
        top: 25px;
        position: absolute;
        width: 750px;
        height: 108px;
        .title {
          line-height: 28px;
          letter-spacing: 1px;
          font-size: 18px;
        }
        .time {
          position: absolute;
          bottom: 0;
          color: #999999;
        }
      }

      .img {
        top: 10px;
        position: absolute;
        right: 10px;
      }
    }
  }

  .boxright {
    margin-top: 5px;
    box-shadow: 0px 1px 10px 10px #fafafa;
    // box-shadow-right:
    width: 345px;
    height: 89%;
    box-sizing: border-box;
    padding-left: 22px;
    border-radius: 12px;
    .top {
      font-size: 22px;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .item2 {
      position: relative;
      height: 310px;
      margin-bottom: 20px;

      .le2 {
        // top: 25px;
        position: absolute;
        width: 285px;
        height: 112px;
        border-bottom: 2px solid #fafafa;
        .title {
          color: #333333;

          letter-spacing: 1px;
          font-size: 16px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          color: #999999;
        }
      }

      img {
        width: 300px;
        height: 180px;
        margin-bottom: 15px;
      }
    }

    .item3 {
      position: relative;
      height: 112px;
      margin-bottom: 30px;

      .le2 {
        // top: 25px;
        position: absolute;
        width: 285px;
        height: 112px;
        border-bottom: 2px solid #fafafa;
        .title {
          color: #333333;

          letter-spacing: 1px;
          font-size: 16px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          color: #999999;
        }
      }
    }
  }
}
</style>
